import React from 'react';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { riskToleranceOpts } from './RiskTolerance.meta';
import { MarginProps } from '../../../../theme/styledProps';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const fieldName = 'riskTolerance';

export const RiskTolerance: React.FC<MarginProps> = props => {
  const formBag = useFormContext();
  const {
    formState: { errors },
  } = formBag;

  return (
    <Wrapper {...props}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            innerRef={field.ref}
            value={riskToleranceOpts.find(({ value }) => value === field.value)}
            label="What is your risk tolerance?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value, { shouldValidate: true });
              }
            }}
            options={riskToleranceOpts}
            formVariant={get(errors, fieldName) ? 'error' : undefined}
            helperText={get(errors, fieldName)?.message}
          />
        )}
      />
    </Wrapper>
  );
};
